import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

const EditMassMessageGate = () => {
  const flags = useFlags();
  const { messageId } = useParams();

  // When events flag is on, redirect to the combined details/edit view
  if (flags.events) return <Redirect to={`/Messaging/mass-messaging/${messageId}`} />;
  return null;
};

export default EditMassMessageGate;
